module.exports = __webpack_public_path__ + "static/media/fr_MIDBooklet_serialnum@2x.14496edb.png";